import React, { FC } from 'react';
import Button from '../Button';
import InputWithActionStyled from './InputWithActionStyled';
import { InputWithActionProps } from './types';
import useMediaQuery from '~/hooks/useMediaQuery';
import Input from '../Input';
import ErrorMessage from '../ErrorMessage';

const InputWithAction: FC<InputWithActionProps> = ({
  placeholder,
  buttonText,
  leftIcon,
  inputType = 'text',
  loading = false,
  disabled = false,
  ariaLabel,
  testId,
  className,
  error,
  registerProps,
  id,
  autoComplete,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const isSubmitDisabled = disabled || loading;

  return (
    <>
      <InputWithActionStyled className={className} data-testid={testId}>
        <div className="input-with-action__container">
          <div className="icon icon--left">{leftIcon}</div>

          <Input
            type={inputType}
            placeholder={placeholder}
            className="input-with-action__input"
            aria-label={ariaLabel || placeholder}
            disabled={disabled}
            id={id}
            autoComplete={autoComplete}
            registerProps={registerProps}
          />

          {!isMobile && (
            <Button
              disabled={isSubmitDisabled}
              loading={loading}
              className="input-with-action__button input-with-action__button__tablet-up"
              type="submit"
              data-testid={`${testId || 'input-with-action'}-submit-desktop`}
            >
              {buttonText}
            </Button>
          )}
        </div>

        {isMobile && (
          <Button
            disabled={isSubmitDisabled}
            loading={loading}
            className="input-with-action__button__mobile"
            type="submit"
            data-testid={`${testId || 'input-with-action'}-submit-mobile`}
          >
            {buttonText}
          </Button>
        )}
      </InputWithActionStyled>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
};

InputWithAction.displayName = 'InputWithAction';

export default InputWithAction;
